/*
 * kelltoncommerce
 * version 1.0
 * http://www.kelltoncommerce.com
 *
 * Copyright (c) 2023  kellton tech solution limited
 * Author kellton ltd <support@kellton.com>
 * Licensed under the MIT license.
 */
export class RegisterModel {
  firstName: String;
   lastName: String;
   password: String;
   confirmPassword: String;
   emailId: String;
   phoneNumber: Number;

  constructor(registerRequest: any) {
    this.firstName = registerRequest.fName || '';
    this.lastName = registerRequest.lName || '';
    this.password = registerRequest.password || '';
    this.confirmPassword = registerRequest.confirmPassword || '';
    this.emailId = registerRequest.email || '';
    this.phoneNumber = registerRequest.phoneNumber || '';
  }
}
